import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42116dd1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bgbox" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "yuedubox" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "nav",
      onClick: $setup.backRouter
    }, [
      _createVNode(_component_van_icon, {
        name: "arrow-left",
        size: "22"
      }),
      _createElementVNode("div", null, _toDisplayString(_ctx.$t('me.jxgg')), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: $setup.loginimg,
        alt: "loginbg"
      }, null, 8 /* PROPS */, _hoisted_2)
    ]),
    _createVNode(_component_van_cell_group, {
      inset: "",
      class: "inputGroup"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_field, {
          modelValue: $setup.userName,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => (($setup.userName) = $event)),
            $setup.checkText
          ],
          type: "text",
          label: $setup.t('me.zhen'),
          placeholder: $setup.t('me.inputname'),
          style: {"height":"50px","line-height":"50px","padding":"0px 10px"}
        }, null, 8 /* PROPS */, ["modelValue", "label", "placeholder"])
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_van_cell_group, {
      inset: "",
      class: "inputGroup"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_field, {
          modelValue: $setup.password,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event)),
            $setup.checkText
          ],
          type: "password",
          center: "",
          clearable: "",
          label: $setup.t('me.mm'),
          placeholder: $setup.t('me.srmi'),
          style: {"height":"50px","line-height":"50px","padding":"0px 10px"}
        }, null, 8 /* PROPS */, ["modelValue", "label", "placeholder"])
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", {
      class: "toPass",
      onClick: $setup.backRouter
    }, _toDisplayString(_ctx.$t('me.yzmdl')), 1 /* TEXT */),
    _createElementVNode("div", {
      onClick: $setup.doLogin,
      class: "Loginbtn",
      block: ""
    }, _toDisplayString(_ctx.$t('me.dl')), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_checkbox, {
        modelValue: $setup.checked,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.checked) = $event)),
        "icon-size": "16px"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('me.wyydbty')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"]),
      _createCommentVNode(" /download/serviceAgreement_b.html "),
      _createCommentVNode(" <a class=\"xieyi\" :href=\"`${Platform.address}//download/serviceAgreement_b.html`\">{{$t('me.rjfwyx')}}</a> "),
      _createElementVNode("a", {
        class: "xieyi",
        target: "_blank",
        href: $setup.xyData
      }, _toDisplayString(_ctx.$t('me.rjfwyx')), 9 /* TEXT, PROPS */, _hoisted_4)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}